import { fetchRequest } from "@providers/conect";

// Consulta servicios por sku y empresa en API local
const viewServicioPorSkuEmpresaApi = async (data) => {
  try {
    const url = `servicios/v2/by-sku-empresa`;
    const response = await fetchRequest(url, {
      method: "POST",
      body: data,
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { viewServicioPorSkuEmpresaApi };